import React from 'react';

export enum SVGName {
  BIK = 'BIK',
}
interface SVGFactoryProps {
  name: SVGName;
  color?: string;
}
const SVGFactory = (props: SVGFactoryProps) => {
  const { name, color } = props;
  return (
    <>
      {name === SVGName.BIK && (
        <svg
          width="28"
          height="10"
          viewBox="0 0 28 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28 8.21913C28 9.20256 27.1629 9.99979 26.1302 9.99979C25.0976 9.99979 24.2605 9.20256 24.2605 8.21913C24.2605 7.2357 25.0976 6.43848 26.1302 6.43848C27.1629 6.43848 28 7.2357 28 8.21913Z"
            fill="#A2A2A2"
          />
          <path
            d="M0.388011 9.9487C0.288521 9.9487 0.19898 9.91553 0.119388 9.84921C0.0397961 9.77341 0 9.6834 0 9.57917V0.369523C0 0.265299 0.0397961 0.180024 0.119388 0.113699C0.19898 0.0378997 0.288521 0 0.388011 0H5.14861C6.05397 0 6.79517 0.113699 7.37222 0.341098C7.94926 0.568497 8.37707 0.895383 8.65564 1.32176C8.93421 1.74813 9.0735 2.27399 9.0735 2.89933C9.0735 3.22148 9.00385 3.51047 8.86457 3.76629C8.73523 4.01264 8.57605 4.22109 8.38701 4.39164C8.19798 4.55271 8.0189 4.67115 7.84977 4.74695C8.23778 4.90802 8.57605 5.1828 8.86457 5.57127C9.15309 5.95027 9.29735 6.38612 9.29735 6.87881C9.29735 7.54206 9.13817 8.10108 8.8198 8.55588C8.51138 9.01068 8.0587 9.35651 7.46176 9.59339C6.87477 9.83026 6.15346 9.9487 5.29785 9.9487H0.388011ZM3.20856 7.80262H4.95461C5.29287 7.80262 5.5416 7.70787 5.70078 7.51837C5.85997 7.3194 5.93956 7.10148 5.93956 6.8646C5.93956 6.61825 5.85499 6.40507 5.68586 6.22504C5.51673 6.03554 5.27297 5.94079 4.95461 5.94079H3.20856V7.80262ZM3.20856 3.85157H4.80537C5.12374 3.85157 5.35754 3.76629 5.50678 3.59574C5.65601 3.42519 5.73063 3.22622 5.73063 2.99882C5.73063 2.77142 5.65601 2.57245 5.50678 2.4019C5.35754 2.23135 5.12374 2.14608 4.80537 2.14608H3.20856V3.85157Z"
            fill={`${color ?? '#A1A1A1'}`}
          />
          <path
            d="M10.5173 9.9487C10.4179 9.9487 10.3283 9.91553 10.2487 9.84921C10.1691 9.77341 10.1293 9.6834 10.1293 9.57917V0.369523C10.1293 0.265299 10.1691 0.180024 10.2487 0.113699C10.3283 0.0378997 10.4179 0 10.5173 0H13.0543C13.1638 0 13.2533 0.0378997 13.323 0.113699C13.4026 0.180024 13.4424 0.265299 13.4424 0.369523V9.57917C13.4424 9.6834 13.4026 9.77341 13.323 9.84921C13.2533 9.91553 13.1638 9.9487 13.0543 9.9487H10.5173Z"
            fill={`${color ?? '#A1A1A1'}`}
          />
          <path
            d="M15.0795 9.9487C14.98 9.9487 14.8905 9.91553 14.8109 9.84921C14.7313 9.77341 14.6915 9.6834 14.6915 9.57917V0.369523C14.6915 0.265299 14.7313 0.180024 14.8109 0.113699C14.8905 0.0378997 14.98 0 15.0795 0H17.4523C17.5618 0 17.6513 0.0378997 17.721 0.113699C17.8006 0.180024 17.8404 0.265299 17.8404 0.369523V3.35413L20.064 0.298461C20.1137 0.232136 20.1834 0.165812 20.2729 0.0994874C20.3624 0.0331624 20.4868 0 20.646 0H23.377C23.4665 0 23.5411 0.0331624 23.6008 0.0994874C23.6705 0.156337 23.7053 0.227399 23.7053 0.312674C23.7053 0.369523 23.6854 0.421635 23.6456 0.46901L20.5117 4.76116L23.9142 9.47969C23.954 9.51759 23.9739 9.5697 23.9739 9.63602C23.9739 9.7213 23.9391 9.7971 23.8695 9.86342C23.8098 9.92027 23.7351 9.9487 23.6456 9.9487H20.8251C20.636 9.9487 20.4918 9.90606 20.3923 9.82079C20.3027 9.73551 20.248 9.67392 20.2281 9.63602L17.8404 6.33874V9.57917C17.8404 9.6834 17.8006 9.77341 17.721 9.84921C17.6513 9.91553 17.5618 9.9487 17.4523 9.9487H15.0795Z"
            fill={`${color ?? '#A1A1A1'}`}
          />
        </svg>
      )}
    </>
  );
};

export default SVGFactory;
